module.exports = __webpack_public_path__ + "static/media/bi_regular_season_emblem_black.8f57f415.png";